import type theme from '#build/ui-pro/banner'

export default {
	slots: {
		root: [
			'relative z-50 w-full',
			'transition-all duration-150 ease-in-out'
		],
		container: 'flex items-center justify-between gap-3 h-full min-h-12',
		left: 'hidden lg:flex-1 lg:flex lg:items-center',
		center: 'flex items-center gap-1.5 min-w-0',
		right: 'lg:flex-1 flex items-center justify-end',
		icon: 'size-5 shrink-0 text-inverted pointer-events-none',
		title: 'py-2 text-sm text-inverted font-medium truncate pr-1',
		actions: 'flex gap-1.5 shrink-0 isolate',
		close: 'text-inverted hover:bg-default/10 focus-visible:bg-default/10 -me-1.5 lg:me-0'
	},
	variants: {
		color: {
			primary: {
				root: 'bg-primary'
			},
			secondary: {
				root: 'bg-secondary'
			},
			success: {
				root: 'bg-success'
			},
			info: {
				root: 'bg-info'
			},
			warning: {
				root: 'bg-warning'
			},
			error: {
				root: 'bg-error'
			},
			neutral: {
				root: 'bg-inverted'
			}
		},
		to: {
			true: ''
		}
	},
	compoundVariants: [
		{
			color: 'primary',
			to: true,
			class: {
				root: 'hover:bg-primary/90'
			}
		},
		{
			color: 'neutral',
			to: true,
			class: {
				root: 'hover:bg-inverted/90'
			}
		}
	],
	defaultVariants: {
		color: 'primary'
	}
} satisfies Partial<typeof theme>
